export const createDarkFamilyShadows = () => [
    'none',
    '0px 1px 2px rgba(0, 0, 0, 0.26), 0px 1px 1px rgba(0, 0, 0, 0.14)',
    '0px 2px 4px rgba(0, 0, 0, 0.26), 0px 1px 2px rgba(0, 0, 0, 0.14)',
    '0px 3px 8px rgba(0, 0, 0, 0.28), 0px 1px 3px rgba(0, 0, 0, 0.16)',
    '0px 4px 10px rgba(0, 0, 0, 0.28), 0px 2px 4px rgba(0, 0, 0, 0.16)',
    '0px 6px 14px rgba(0, 0, 0, 0.3), 0px 2px 6px rgba(0, 0, 0, 0.16)',
    '0px 8px 18px rgba(0, 0, 0, 0.3), 0px 3px 8px rgba(0, 0, 0, 0.18)',
    '0px 10px 20px rgba(0, 0, 0, 0.32), 0px 4px 10px rgba(0, 0, 0, 0.18)',
    '0px 12px 24px rgba(0, 0, 0, 0.34), 0px 4px 12px rgba(0, 0, 0, 0.2)',
    '0px 14px 28px rgba(0, 0, 0, 0.34), 0px 5px 14px rgba(0, 0, 0, 0.2)',
    '0px 16px 30px rgba(0, 0, 0, 0.36), 0px 6px 16px rgba(0, 0, 0, 0.2)',
    '0px 18px 32px rgba(0, 0, 0, 0.36), 0px 7px 18px rgba(0, 0, 0, 0.2)',
    '0px 20px 34px rgba(0, 0, 0, 0.38), 0px 8px 20px rgba(0, 0, 0, 0.22)',
    '0px 22px 36px rgba(0, 0, 0, 0.38), 0px 9px 22px rgba(0, 0, 0, 0.22)',
    '0px 24px 38px rgba(0, 0, 0, 0.4), 0px 10px 24px rgba(0, 0, 0, 0.22)',
    '0px 26px 40px rgba(0, 0, 0, 0.4), 0px 11px 26px rgba(0, 0, 0, 0.24)',
    '0px 28px 42px rgba(0, 0, 0, 0.42), 0px 12px 28px rgba(0, 0, 0, 0.24)',
    '0px 30px 44px rgba(0, 0, 0, 0.42), 0px 13px 30px rgba(0, 0, 0, 0.24)',
    '0px 32px 46px rgba(0, 0, 0, 0.44), 0px 14px 32px rgba(0, 0, 0, 0.26)',
    '0px 34px 48px rgba(0, 0, 0, 0.44), 0px 15px 34px rgba(0, 0, 0, 0.26)',
    '0px 36px 50px rgba(0, 0, 0, 0.46), 0px 16px 36px rgba(0, 0, 0, 0.26)',
    '0px 38px 52px rgba(0, 0, 0, 0.46), 0px 17px 38px rgba(0, 0, 0, 0.28)',
    '0px 40px 54px rgba(0, 0, 0, 0.48), 0px 18px 40px rgba(0, 0, 0, 0.28)',
    '0px 42px 56px rgba(0, 0, 0, 0.48), 0px 19px 42px rgba(0, 0, 0, 0.28)',
    '0px 44px 58px rgba(0, 0, 0, 0.5), 0px 20px 44px rgba(0, 0, 0, 0.3)'
]
